module.exports = __webpack_public_path__ + "img/22.bdf69cd6.jpg";